import {companyData} from "../../global/change-company";
import {getAltRowTemplate, getRowTemplate, getTemplate} from "./templates";
import {EventTypes} from "../../../constants/event-types";
import KendoGridExport from "../../global/kendo-grid-export";
import deviceExportGrid from "./device-export-grid";
import {setUpGridFilters} from "./asset-management-filter";


const TILE_VIEW = 0;
const GRID_VIEW = 1;

const company = companyData.id;
const companyOptions = companyData.options;
let assetGrid;
let k_exportGrid;
let isGridReadingData = false;

export const createAssetGrid = () => {
    if (assetGrid) return;
    let columns = getGridColumns();
    assetGrid = $('.js-tech-asset-grid').kendoGrid({
        dataSource: {
            type: 'json',
            transport: {
                read: `/Technology/AssetManagement/GetAssets?company=${company}`,
                parameterMap(data, type) {
                    if (type === 'read') {
                        isGridReadingData = true;
                    }
                }
            },
            schema: {
                model: {
                    id: 'EmpNum',
                    fields: {
                        Company: {type: 'string'},
                        EmpNum: {type: 'string'},
                        LastName: {type: 'string'},
                        FirstName: {type: 'string'},
                        Status: {type: 'string'},
                        Title: {type: 'string'},
                        Devices: {type: 'object'},
                        DeviceCount: {type: 'number'},
                        IsActive: {type: 'boolean'}
                    }
                }
            },
        },
        dataBound: function (arg) {
            isGridReadingData = false;
            setupExportGrid();
        },
        height: 700,
        scrollable: true,
        sortable: {
            mode: 'multiple'
        },
        filterable: {
            mode: 'row'
        },
        filter: function (e) {
            setTimeout(function () {
                k_exportGrid = deviceExportGrid();
            }, 1000);
        },
        toolbar: kendo.template($('#template-toolbar').html()),
        search: {
            fields: [{
                name: 'LastName',
                operator: 'contains'
            }]
        },
        detailInit: detailInit,
        columns: columns,
        noRecords: 'No assets match the currently applied filters.'
    }).data('kendoGrid');
    
    setupLayoutToggle();
    setUpGridFilters();
};

const getGridColumns = () => {
    let columns = [];
    if (company === '1') {
        columns.push({
            field: 'Company',
            title: 'Branch',
            template: function (di) {
                const companyInfo = companyOptions.find(e => e.value == di.Company);
                return companyInfo?.name ?? 'Unassigned';
            },
            filterable: {
                cell: {
                    showOperators: false,
                    operator: 'equals',
                    template: function (args) {
                        args.element.kendoDropDownList({
                            dataSource: companyOptions,
                            optionLabel: 'Select branch...',
                            dataTextField: 'name',
                            dataValueField: 'value',
                            valuePrimitive: true
                        });
                    }
                }
            },
            width: '200px'
        });
    }
    return columns.concat([
        {
            field: 'EmpNum',
            title: 'Employee ID',
            filterable: {
                cell: {showOperators: false, operator: 'eq'}
            },
            width: '150px'
        }, {
            field: 'LastName',
            title: 'Last Name',
            filterable: {
                cell: {showOperators: false, operator: 'contains'}
            }
        }, {
            field: 'FirstName',
            title: 'First Name',
            filterable: {
                cell: {
                    showOperators: false, operator: 'contains',
                }
            }
        }, {
            field: 'Status',
            title: 'Status',
            filterable: {
                cell: {
                    showOperators: false, operator: 'eq',
                    template: function (args) {
                        args.element.kendoDropDownList({
                            dataSource: [{
                                    name: 'Active',
                                    value: 'Y'
                                }, {
                                    name: 'Inactive',
                                    value: 'N'
                                }
                            ],
                            optionLabel: 'Select status...',
                            dataTextField: 'name',
                            dataValueField: 'value',
                            valuePrimitive: true
                        });
                    }
                }
            },
            template: function (di) {
                const rawStatus = di.Status;
                if (rawStatus === 'Y') return '<span class="tag tag--small tag--green">Active</span>';
                if (rawStatus === 'N') return '<span class="tag tag--small tag--red">Inactive</span>';
                return "<span class='tag tag--small'>No Status</span>";
            }
        }, {
            field: 'DeviceCount',
            title: 'Devices',
            filterable: {
                cell: {
                    showOperators: false,
                    operator: 'eq',
                }
            },
            template: function (di) {
                const devices = di.Devices;
                if (devices.length === 0) return `<span class='tag tag--small tag--red'>No Devices Assigned</span>`;
                const phoneData = devices.filter(p => p.Type === 'Phone');
                const tabletData = devices.filter(t => t.Type === 'Tablet');
                const computerData = devices.filter(c => c.Type === 'Computer');

                let template = '';
                if (phoneData.length > 1) template += `<span class='tag tag--small tag--device'>${phoneData.length} Phones</span>`;
                else if (phoneData.length === 1) template += `<span class='tag tag--small tag--device'>1 Phone</span>`;

                if (tabletData.length > 0) template += `<span class='tag tag--small tag--device'>${tabletData.length} Tablets</span>`;
                else if (tabletData.length === 1) template += `<span class='tag tag--small tag--device'>1 Tablet</span>`;

                if (computerData.length > 0) template += `<span class='tag tag--small tag--device'>${computerData.length} Computers</span>`;
                else if (computerData.length === 1) template += `<span class='tag tag--small tag--device'>1 Computer</span>`;

                return template;
            }
        }
    ]);
};

const detailInit = function (e) {
    const $layoutToggle = $('.js-layout-toggle');
    const viewValue = $layoutToggle.data('value');
    if (viewValue === TILE_VIEW) createTileView(e);
    if (viewValue === GRID_VIEW) createGridView(e);
};

const createTileView = (e) => {
    const k_listview_dataSource = new kendo.data.DataSource({
        data: e.data.Devices,
        pageSize: 14
    });
    const k_listview = $('<div/>').appendTo(e.detailCell).kendoListView({
        dataSource: k_listview_dataSource,
        template: getTemplate,
        selectable: 'single'
    }).data('kendoListView');

    if (k_listview) {
        const k_pager = $('<div class="devices-pager">').appendTo(e.detailCell).kendoPager({
            dataSource: k_listview.dataSource,
            pageSizes: [14, 'all'],
            numeric: true
        }).data('kendoPager');
        k_listview_dataSource.bind('change', function (e) {
            k_listview.element.find('div.device.found').removeClass('found');
            k_listview.element.find('.k-listview-content .device').bind('click', function (e) {
                $.event.trigger(EventTypes.OpenTechDetails, [e]);
            });
        });
        e.detailCell.find('div.device.found').removeClass('found');
        k_listview.element.find('.k-listview-content .device').bind('click', function (e) {
            $.event.trigger(EventTypes.OpenTechDetails, [e]);
        });
    }
};

const createGridView = (e) => {
    const k_gridview_dataSource = new kendo.data.DataSource({
        data: e.data.Devices,
        pageSize: 10
    });

    const k_gridview = $('<div/>').appendTo(e.detailCell).kendoGrid({
        dataSource: k_gridview_dataSource,
        dataBound: function (arg) {
            setupClickableRow(arg);
        },
        columns: [
            {
                title: 'Device Type',
                field: 'Type'
            },
            {
                title: 'Device Name',
                field: 'Name'
            },
            {
                title: 'Device Status',
                field: 'Status'
            }
        ],
        rowTemplate: getRowTemplate,
        altRowTemplate: getAltRowTemplate,
        pageable: {
            alwaysVisible: true,
            pageSizes: [5, 10, 25, 50, 'all'],
            buttonCount: 5
        },
        noRecords: {
            template: "There are no devices."
        }
    }).data('kendoGrid');
};

const setupExportGrid = () => {
    k_exportGrid = deviceExportGrid();
    KendoGridExport($('span.js-grid-export'), k_exportGrid);
};

const isFound = (device) => {
    return foundDevices.some(foundDevice => foundDevice.Type === device.Type && foundDevice.Id === device.Id);
};

const setupLayoutToggle = () => {
    const $layoutToggle = $('.js-layout-toggle');
    $layoutToggle.unbind('click');
    $layoutToggle.bind('click', (e) => {
        const viewValue = $layoutToggle.data('value');

        if (viewValue === 0) {
            $layoutToggle.text('Switch to tile subview')
            $layoutToggle.data('value', 1);
        }
        if (viewValue === 1) {
            $layoutToggle.text('Switch to grid subview')
            $layoutToggle.data('value', 0);
        }

        if (assetGrid && !isGridReadingData) assetGrid.dataSource.read();
    })
}

const setupClickableRow = (arg) => {
    const $grid = arg.sender;
    const $element = $grid.element;
    const $rows = $element.find('tbody [role="row"]');

    $rows.css('cursor', 'pointer');

    $rows.on('click', (e) => {
        $.event.trigger(EventTypes.OpenTechDetails, [e]);
    });
}